export default __webpack_public_path__ + "static/media/info.3e23ef89.svg";